"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

require("./index.css");

var index_1 = require("../../index");

var ComplexityScale = function (_a) {
  var dataTestId = _a.dataTestId,
      originalValue = _a.originalValue,
      originalLabel = _a.originalLabel,
      modifiedValue = _a.modifiedValue,
      modifiedLabel = _a.modifiedLabel,
      backgroundColor = _a.backgroundColor,
      showTooltip = _a.showTooltip,
      highLow = _a.highLow;
  var trackValue = modifiedValue !== null && modifiedValue !== void 0 ? modifiedValue : originalValue;
  var scaleClasses = 'complexity-scale';
  if (highLow) scaleClasses += ' show-range'; // avoid repeated elements in component

  var slices = Array.from('123456789');
  var numbers = Array.from('0123456789');
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: scaleClasses,
    "data-testid": dataTestId
  }, {
    children: [highLow && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "complexity-range"
    }, {
      children: [(0, jsx_runtime_1.jsx)("span", {
        children: "Low"
      }, void 0), (0, jsx_runtime_1.jsx)("span", {
        children: "High"
      }, void 0)]
    }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "complexity-bar"
    }, {
      children: [modifiedValue > 0 && (0, jsx_runtime_1.jsx)("div", {
        className: "complexity-bullet-hollow",
        style: {
          clipPath: "ellipse(calc(var(--bullet-half) * 1.25) calc(var(--bullet-half) * 1.25) at calc(" + originalValue * 10 + "% - 5%) 50%)",
          background: "var(--" + backgroundColor + ")"
        }
      }, void 0), (0, jsx_runtime_1.jsx)("div", {
        className: "complexity-bullet",
        "data-testid": dataTestId + "-initial-bullet",
        style: {
          clipPath: "ellipse(var(--bullet-full) var(--bullet-full) at calc(" + originalValue * 10 + "% - 5%) 50%)"
        }
      }, void 0), modifiedValue > 0 && (0, jsx_runtime_1.jsx)("div", {
        className: "complexity-bullet",
        "data-testid": dataTestId + "-modified-bullet",
        style: {
          clipPath: "ellipse(var(--bullet-full) var(--bullet-full) at calc(" + modifiedValue * 10 + "% - 5%) 50%)"
        }
      }, void 0), showTooltip && (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "complexity-tips"
      }, {
        children: [(0, jsx_runtime_1.jsx)(index_1.Tooltip, __assign({
          direction: "top",
          dataTestId: dataTestId + "-original-label",
          tip: originalLabel,
          showingInitial: true,
          style: {
            width: "calc(" + originalValue * 10 * 2 + "% - 10%)"
          }
        }, {
          children: "\u00A0"
        }), void 0), (0, jsx_runtime_1.jsx)(index_1.Tooltip, __assign({
          direction: "top",
          dataTestId: dataTestId + "-modified-label",
          tip: modifiedLabel,
          showingInitial: true,
          style: {
            width: "calc(" + modifiedValue * 10 * 2 + "% - 10%)"
          }
        }, {
          children: "\u00A0"
        }), void 0)]
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "slices"
      }, {
        children: slices.map(function (slice) {
          return (0, jsx_runtime_1.jsx)("div", {
            style: {
              background: "var(--" + backgroundColor + ")"
            }
          }, slice);
        })
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "complexity-container",
        "data-testid": dataTestId + "-container"
      }, {
        children: (0, jsx_runtime_1.jsx)("div", {
          className: "complexity-indicator",
          style: {
            clipPath: "polygon(-5px 0, " + (trackValue * 10 - 5) + "% 0, " + (trackValue * 10 - 5) + "% 100%, -5px 100%)"
          }
        }, void 0)
      }), void 0)]
    }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "numbers"
    }, {
      children: numbers.map(function (num) {
        return (0, jsx_runtime_1.jsx)("span", {
          children: parseInt(num, 10) + 1
        }, num);
      })
    }), void 0)]
  }), void 0);
};

ComplexityScale.propTypes = {
  dataTestId: prop_types_1.string,
  originalValue: prop_types_1.number.isRequired,
  originalLabel: prop_types_1.string.isRequired,
  modifiedValue: prop_types_1.number,
  modifiedLabel: prop_types_1.string,
  backgroundColor: prop_types_1.string,
  showTooltip: prop_types_1.bool,
  highLow: prop_types_1.bool
};
ComplexityScale.defaultProps = {
  dataTestId: 'complexity',
  modifiedValue: null,
  modifiedLabel: null,
  backgroundColor: 'background-default',
  showTooltip: false,
  highLow: false
};
exports.default = ComplexityScale;